export default __webpack_public_path__ + "static/media/mc-3.e82df7b7.jpg";